<template>
	<div v-once id="quickemail">


		<!--MV-->
		<section class="hero">
			<div class="wrapper sp">
				<img src="/kr/resume/static/renew_img/quickemail/mv01.png" alt="사용자의목소리를반영" class="mv01">
				<div class="voice">
					<img src="/kr/resume/static/renew_img/quickemail/mv02.png" alt="이력서를바로전송하고싶다" class="voice_img">
					<div class="voice_list">
						<p>"기업의 채용메일로 발송 하고싶요"</p>
						<p>"등록한 메일주소가 제 메일인가요?"</p>
						<p>"접수처의 메일로 송신하고 싶어요"</p>
					</div>
				</div>
				<div class="yagideco01">
					<img src="/kr/resume/static/renew_img/quickemail/mv04.png" alt="야기메일서비스개시" class="yagideco01_01">
					<img src="/kr/resume/static/renew_img/quickemail/mv05.png" alt="귀찮은작업해소" class="yagideco01_02">
				</div>
			</div>
			<div class="wrapper pc">
				<img src="/kr/resume/static/renew_img/quickemail/mv06.png" alt="야기메일서비스개시" class="mv06">
				<div class="yagideco01">
					<img src="/kr/resume/static/renew_img/quickemail/mv04.png" alt="야기메일서비스개시" class="yagideco01_01">
				</div>
			</div>
		</section>

		<div class="cv-block">
			<img src="/kr/resume/static/renew_img/quickemail/nedan01.png" alt="220円" class="cv-img">
			<p class="cv-txt01">"이력서를 메일로 보내줘."</p>
			<p class="cv-txt02">↓↓↓라고 기업의 공고사항이 있었다면↓↓↓</p>
			<a href="https://rirekisho.yagish.jp/quickemail/basic" target="_blank"
				class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic">야기메일<span class="cv-btn_small">을 사용</span></a>
		</div>

		<!--アピールポイント-->
		<section class="second">
			<h2 class="h2">이러한 기능에 충실!</h2>
			<div class="wrapper sp-flex pr_block">
				<img src="/kr/resume/static/renew_img/quickemail/pr01.png" alt="평소와 같이 작성할 뿐" class="pr_item">
				<img src="/kr/resume/static/renew_img/quickemail/pr02.png" alt="기업이 확인하면 알림이 옵니다" class="pr_item">
				<img src="/kr/resume/static/renew_img/quickemail/pr03.png" alt="실수해버렸어,전송취소도 OK" class="pr_item">
				<img src="/kr/resume/static/renew_img/quickemail/pr04.png" alt="패스워드 설정 시큐리티" class="pr_item">
			</div>
		</section>

		<!--使い方-->
		<section class="third">
			<div class="wrapper">
				<h2 class="h2">야기메일 사용업</h2>
				<ul class="step">
					<li class="sp-flex step_item">
						<p class="step_number">①</p>
						<p>평소와 같이 야기슈를 사용해서<br class="sp"><span class="step_bold">이력서・경력기술서 작성!</span></p>
					</li>
					<li class="sp-flex step_item">
						<p class="step_number">②</p>
						<p>야기 메일을 이용해<br class="sp"><span class="step_bold">지원기업의 정보를 입력</span></p>
					</li>
					<li class="step_item">
						<div class="sp-flex step_item_03">
							<p class="step_number">③</p>
							<p>야기메일 "구입"과 동시에<br class="sp"><span class="step_bold">지원기업의 발송 성공!</span></p>
						</div>
						<div class="preview01">
							<p class="preview_ti">수신메일화면</p>
							<img src="/kr/resume/static/renew_img/quickemail/preview01.png" alt="수신메일화면"
								class="preview_img01">
							<p class="step_small preview01_txt">※이용하시는 메일 서비스에 따라 화면이 다를 수 있습니다.</p>
						</div>
						<div class="preview02">
							<p class="preview_ti">기업 다운로드 화면</p>
							<img src="/kr/resume/static/renew_img/quickemail/preview02.png" alt="기업 다운로드 화면"
								class="preview_img02">
						</div>
					</li>
					<li class="sp-flex step_item">
						<p class="step_number">④</p>
						<p>지원한 기업이 당신의 PDF를 확인하면<br class="sp"><span class="step_bold">메일 알림이 도착합니다!</span><br>
							<span class="step_small">※열람알림은 채용 합격 여부와는 관계가 없습니다.기업에 따라 채용안내에 대한 연락 방법은 다를 수 있습니다.</span>
						</p>
					</li>
				</ul>
			</div>
		</section>

		<div class="cv-block cv-block02">
			<img src="/kr/resume/static/renew_img/quickemail/nedan02.png" alt="2200원" class="cv-img">
			<a href="https://rirekisho.yagish.jp/quickemail/basic" target="_blank"
				class="cv-btn cv-btn--red cv-btn--radius cv-btn--cubic">야기메일<span class="cv-btn_small">을 사용</span></a>
		</div>

		<div style="text-align: center; padding: 20px;">
			<a href="/kr/resume/quickemailterms" target="_blank">이용약관<span style="color: #E3165C;">이쪽</span></a>
		</div>

	</div>
</template>
<style lang="css" src="@/assets/css/quickemail_stylesheet.css"></style>
<style lang="css" src="@/assets/css/quickemail_reset.css"></style>

<style lang="scss" scoped></style>

<script>
export default {
	data: function () {
		return {
			question1: false,
			question2: false,
			question3: false,
			question4: false,
			question5: false,
			question6: false,
			question7: false,
			question8: false
		}
	},
	computed: {},
	methods: {
		viewAnswer: function (name) {
			console.error(name)
			this.question1 = true
		}
	},
	watch: {},
	mounted: function () { }
}
</script>
